// lib
import { call } from 'redux-saga/effects'
import { imageUpload } from '@aytm/app/insights/dashboard/lib/image'

// stores
import staticStore from '@aytm/app/insights/dashboard/stores/static.store'

/**
 *
 * @param {File} file
 */
export function* imageUploadSaga(file) {
  const createImageAssetPathURL = staticStore.urls.createImageAssetPath
  if (!createImageAssetPathURL) {
    throw new Error('No "createImageAssetPath" endpoint URL')
  }
  return yield call(imageUpload, createImageAssetPathURL, file)
}
